<div class="business-flow col-12 ml-2">
    <form [formGroup]="userForm" (ngSubmit)="submitForm()">
        <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center col-6 mb-2 m-0 p-0">
                <h3 class=" pt-1">Test Manager</h3>
                <ui-switch class="m-2 pt-1" size="small" (change)="changeLoadTestType($event)"
                    [checked]="loadTestType==='API' ? true : false" checkedLabel="API" uncheckedLabel="WEB"
                    defaultBgColor="#cf6250" checkedTextColor="#fff" uncheckedTextColor="#fff"></ui-switch>
            </div>
            <div class="d-flex align-items-center col-6 justify-content-end m-0 p-0">
                <div class="col-4">
                    <!-- <label>Environment</label> -->
                    <ng-select class="custom-style" required formControlName="environment" id="locator-types"
                        [items]="perfEnvironments" bindLabel="name" placeholder="Select Environment"
                        [searchable]="true">
                        <ng-option>Select</ng-option>
                    </ng-select>

                </div>
                <div>
                    <button class="float-right btn btn-sm btn-primary">
                        {{userForm.value.schedule ? 'Schedule' : 'Run'}} the Test</button>
                </div>
            </div>
        </div>
        <div class="singleExcSec d-flex col-12 align-items-center justify-content-center">
            <div class=" pb-3 col-3">
                <label>Project</label>
                <ng-select class="required custom-style" (clear)="clearForm('project')" required
                    formControlName="projectName" id="locator-types" [items]="userProjects" bindLabel="name"
                    placeholder="Select Project" [searchable]="true" (change)="fetchTestCase($event)">
                    <ng-option [value]="">Select</ng-option>
                </ng-select>
            </div>
            <div class="pb-3 col-3">
                <label>Test Case</label>
                <ng-select class="required custom-style" (clear)="clearForm('')" required formControlName="testCaseName"
                    id="test-case" [items]="testCasesList" bindLabel="name" placeholder="Select Testcase"
                    [searchable]="true" (change)="getLoadTestConfig($event)">
                    <ng-option [value]="">Select</ng-option>
                </ng-select>
            </div>
            <div class="pb-3 col-3">
                <label>Load Test Config</label>
                <ng-select class="required custom-style" required formControlName="loadTestConfigName"
                    id="locator-types" [items]="loadTestConfig" bindLabel="name" placeholder="Select LoadTestConfig"
                    [searchable]="true" (change)="selectedLoadTestCofig($event, false)">
                    <ng-option [value]="">Select</ng-option>
                </ng-select>
            </div>
            <div class="col-1 mb-4 text-center">
                <label>Schedule</label><br>
                <ui-switch (change)="changeScheduleMethod()" formControlName="schedule" size="small" checkedLabel="True"
                    uncheckedLabel="False" defaultBgColor="#cf6250" checkedTextColor="#fff"
                    uncheckedTextColor="#fff"></ui-switch>
            </div>
            <div class="col-2 scheduleSec" [ngClass]="{'show':userForm.value.schedule}">
                <span>
                    <label>Schedule Here</label>
                    <!-- <input formControlName="scheduledTime" style="padding: 3px;font-size: 16px;width: 100%;"
                        class="custom-style" type="datetime-local"> -->
                    <input class="form-control bg-white datepicker" formControlName="scheduledTime"
                        type="datetime-local" data-enable-time="true">
                    <p class="text-right"><b>PST Now :</b>{{getCurrentTime()}}</p>
                </span>
            </div>
        </div>
    </form>
    <div *ngIf="selectedLoadTestConfig">
        <div class='col-12 loadTestSection px-3 pt-1 pb-5'>
            <app-thread-group-page [newLoadTestCase]="selectedTestCase"
                (updatedLoadTestConfig)="updatedLoadTestConfig($event)" showComment="true" [comment]="comment"
                [selectedLoadTestConfig]="selectedLoadTestConfig"></app-thread-group-page>
        </div>
    </div>
</div>